import "./StatsBlock.css";

function StatsBlock({ icon, value, label, description }) {
  return (
    <section className="block stats-block">
      <div className="stats-content">

        {/* LEFT */}
        <div className="stats-left">
          <div className="stats-icon">
            {icon && <img src={icon} alt="Installed Capacity" />}
          </div>
          <h2 className="stats-value">{value || ''}</h2>
        </div>

        {/* RIGHT */}
        <div className="stats-right">
          <h3>{label || ''}</h3>
          <p>{description || ''}</p>
        </div>

      </div>
    </section>
  );
}

export default StatsBlock;
